

require("uiUtils");
define(['angular', 'text!./template.html', 'squid/index', 'xo-models/src/address/index', 'xo-form-components/src/zipcode/directive'], function (angular, template) {
  return angular.module('xo-add-card.addcep.directive', ['squid', 'xomodel.address', 'xo-zipcode.directive']).directive('xoAddCep', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        sidebar: '=?',
        prefillAddress: '=?',
        doneFn: '=?'
      },
      controller: ['$scope', '$populate', '$state', '$PrefillAddressModel', '$locale', function ($scope, $populate, $state, $PrefillAddressModel, $locale) {
        $scope.country = $locale.country;
        $scope.address = {};
        $scope.onSubmit = function () {
          $scope.prefillAddress.address = {
            country: $locale.country,
            postal_code: $scope.address.postal_code
          };
          $scope.prefillAddress.save({
            data: $scope.prefillAddress,
            success: function success(result) {
              $scope.prefillAddress.address = result;
              $scope.doneFn();
            }
          });
        };
      }]
    };
  }]);
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/addCep/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-card/addCep/directive.js
// module chunks = 0